import axios from 'axios';
import TokenService from './token.service';
import store from '@/store/store';

const ApiService = {

	initialized: false,

	init() {
		if (!this.initialized) {
			this.initialized = true;
			axios.defaults.baseURL = process.env.VUE_APP_API_URL;
		}
	},

	setHeader() {
		axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`;
		axios.defaults.headers.common["Council"] = store.getters.getCouncilId;
		axios.defaults.headers.common["Access-Control-Allow-Origin"] = `*`;
	},

	setHeaderMultipart(){
		this.setHeader();
		axios.defaults.headers.common["Content-Type"] = `multipart/form-data`;
	},

	removeHeader() {
		axios.defaults.headers.common = {}
	},

	get(resource, data) {
		//console.log("Axois.get:", resource);
		this.setHeader();
		return axios.get(resource, { params: data })
	},

	post(resource, data) { //, responseType = 'json'
		//console.log("Axois.post:", resource);
		this.setHeader();
		return axios.post(resource, data)
	},

	postFiles(resource, data){
		this.setHeaderMultipart();
		return axios.post(resource, data);
	},

	requestWithOptions(data){
		return axios(data);
	},

	put(resource, data) {
		//console.log("Axois.put:", resource);
		this.setHeader();
		return axios.put(resource, data)
	},

	delete(resource, data) {
		//console.log("Axois.delete:", resource);
		this.setHeader();
		return axios.delete(resource, { params: data })
	}
}

ApiService.init();

export default ApiService;